import { BlurView } from 'expo-blur';
import { Image } from 'expo-image';
import { Button, Box } from 'native-base';
import { theme } from '@breakroom-nx/assets';

// Redux
import { useDispatch } from 'react-redux';
import { openModal } from '@breakroom-nx/redux';

// Assets
import diceImage from '../../../../assets/src/images/dice.webp';

export function RandomButton() {
  const dispatch = useDispatch();

  return (
    <Box
      rounded={'full'}
      style={{
        shadowColor: 'black',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.2,
        shadowRadius: 5,
        borderColor: 'rgba(255, 255, 255, 0.4)',
        borderWidth: 0,
      }}
    >
      <BlurView
        intensity={25}
        tint={'light'}
        style={{ borderRadius: 100, overflow: 'hidden' }}
      >
        <Button
          onPress={() =>
            dispatch(
              openModal({
                modalType: 'Randomizer',
              })
            )
          }
          bg={'transparent'}
          size={'50px'}
          rounded={'full'}
          _pressed={{ backgroundColor: 'rgba(0, 0, 0, 0.15)' }}
          style={{
            shadowColor: theme.colors.surface[200],
            shadowOpacity: 0.35,
            shadowOffset: { width: 0, height: 3 },
            shadowRadius: 5,
          }}
        >
          <Image
            source={{ uri: diceImage }}
            cachePolicy={'memory-disk'}
            accessibilityLabel={`Dice Image`}
            style={{
              width: '30px',
              aspectRatio: 1,
            }}
          />
        </Button>
      </BlurView>
    </Box>
  );
}
